import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import Loader from "@components/loader";
import { Link } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { dashboardInterstateListingHeader, routes, sourceId } from "@utils/constant";
import checkedIconOrange from "@assets/images/cheked-icon-orange.svg";
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import indeterminateIcon from "@assets/images/indeterminate-check-box-icon-orange.svg";
import {
  dashboardRequestStatusColors,
  utcToTimezone,
} from "@utils/commonFunctions";

import { useStore } from "@store/store";
import closeIcon from "@assets/images/close.svg";
import { SelectJobStyle } from "./style";

function SelectJobPopup(props) {
  const classes = SelectJobStyle();
  const [scroll] = useState("body");
  const [state] = useStore();
  const isSelected = (id) => props?.selectedJobArray?.findIndex((job) => job.jobId === id) !== -1;
  const numberSelected = props.selectedJobArray.length;
  const totalRows = state.job?.interstateJobsReassignData?.length || 0;
  const jobDetail = totalRows > 0 ? state.job?.interstateJobsReassignData[0] : {};

  return (
    <>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
        scroll={scroll}
        disableEnforceFocus={false}
        disableRestoreFocus={false}
      >
        <div className="close-modal">
          <img src={closeIcon} alt="Close" onClick={props.handleClose} />
        </div>
        {props.error && <Alert severity="error">{props.error}</Alert>}
        <DialogTitle id="alert-dialog-title">
          Select Jobs
        </DialogTitle>
        <div className="info-driver">
          <div className="info-driver-content">
            <span>Driver:</span><b>{jobDetail?.drivers?.name}</b>
          </div>
          <div className="info-driver-content">
            <span>Truck:</span><b>{
              jobDetail?.trucks?.truckType
                ? `${jobDetail?.trucks?.rego} - ${jobDetail?.trucks?.truckType.name}`
                : jobDetail?.trucks
                  ? jobDetail?.trucks?.rego
                  : "-"
            }</b>
          </div>
          <div className="info-driver-content">
            <span>Trailer:</span><b>{
              jobDetail?.trailers?.trailerType
                ? `${jobDetail?.trailers?.rego} - ${jobDetail?.trailers?.trailerType.name}`
                : jobDetail?.trailers
                  ? jobDetail?.trailers?.rego
                  : "-"
            }</b>
          </div>
        </div>
        <div className={classes.TableWrapper}>
          <Loader loading={state.job?.gettingInterstateJobsReassign} />
          <TableContainer
            component={Paper}
            className={classes.customTable}
          >
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className="check">
                    <FormControlLabel
                      className="custom-checkbox"
                      control={
                        <Checkbox
                          icon={<img src={uncheckedIcon} alt="CheckBox" />}
                          checkedIcon={
                            <img src={checkedIconOrange} alt="CheckBox" />
                          }
                          indeterminateIcon={
                            <img src={indeterminateIcon} alt="CheckBox" />
                          }
                          indeterminate={
                            numberSelected > 0 && numberSelected < totalRows
                          }
                          onChange={(e) => props.handleMainChange(e)}
                          checked={totalRows > 0 && numberSelected === totalRows}
                          name="check"
                        />
                      }
                    />
                  </TableCell>

                  {dashboardInterstateListingHeader.map((item, index) => {
                    return !["driver", "truck", "trailer", "net-charge", "completion-date"].includes(item.className) && (
                      <TableCell key={index} className={item.className}>
                        <div className="flex-box">
                          <span className="title-cell">{item.title}</span>
                          {item.sort && (
                            <TableSortLabel
                              direction={
                                props.orderBy === item.sortTitle
                                  ? props.order
                                  : "desc"
                              }
                              active={true}
                              onClick={(e) => props.handleSorting(e, item)}
                            />
                          )}
                        </div>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {state.job?.interstateJobsReassignData?.length === 0 ? (
                  <TableRow className="no-data">
                    <TableCell colSpan={13}>
                      <span>No Data Found</span>
                    </TableCell>
                  </TableRow>
                ) : (
                  state.job?.interstateJobsReassignData?.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    return (
                      <TableRow key={index}>

                        <TableCell className="check">
                          <FormControlLabel
                            className="custom-checkbox"
                            control={
                              <Checkbox
                                icon={<img src={uncheckedIcon} alt="CheckBox" />}
                                checkedIcon={
                                  <img src={checkedIconOrange} alt="CheckBox" />
                                }
                                onChange={() => props.handleChange(row)}
                                checked={isItemSelected}
                                name="check"
                              />
                            }
                          />
                        </TableCell>
                        <TableCell className="jobId">
                          <Link
                            to={`${routes.interstateJobDetail}/${row.id}`}
                            target="_blank"
                          >
                            {row.id ? row.id : "-"} {row?.sources ? row?.sources?.id === sourceId.CARGO_WISE ? "*" : "" : ""}
                          </Link>
                        </TableCell>
                        <TableCell className="city">{row?.cities?.name || "-"}</TableCell>
                        <TableCell
                          className={`status ${dashboardRequestStatusColors(
                            row.jobStatuses ? row.jobStatuses.name : ""
                          )}`}
                        >
                          <span>
                            {row.jobStatuses ? row.jobStatuses.name : "-"}
                          </span>
                        </TableCell>
                        <TableCell className="customerName break-word">
                          {row.customers ? row.customers.name : "-"}
                        </TableCell>
                        <TableCell className="pickUpLocation break-word">
                          {row?.pickUpLocation ? row?.pickUpLocation : "-"}
                        </TableCell>
                        <TableCell className="dropOffLocation break-word">
                          {row?.dropOffLocation ? row?.dropOffLocation : "-"}
                        </TableCell>
                        <TableCell className="date">
                          {row?.createdAt
                            ? utcToTimezone(
                              row?.createdAt,
                              row?.cities?.timezone,
                              "DD/MM/YYYY"
                            )
                            : "-"}
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <DialogActions className="bottom-button-block">
          <Button
            className="primary-btn gray-border-btn"
            color="inherit"
            disableElevation
            onClick={props.handleClose}
          >
            CANCEL
          </Button>
          <Button
            className="orange-btn primary-btn center-loading-indicator"
            color="inherit"
            disableElevation
            onClick={props.handleConfirmSelectJob}
            disabled={
              props.selectedJobArray.length === 0
            }
          >
            CONFIRM
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SelectJobPopup;
